//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    sourceClaim: {
      type: Object,
      default: null
    }
  },
  computed: {
    turnHLRouteSource: function () {
      return this.getRouteSourceByType('turnHL')
    },
    turnTotal: function () {
      return this.getChildrenBlockByType('turnTotal')
    },
    totalTurnVkAmount: function () {
      return this.getChildrenBlockByType('totalTurnVkAmount')
    },
    totalTurnNkAmount: function () {
      return this.getChildrenBlockByType('totalTurnNkAmount')
    },
    totalTurnVpkAmount: function () {
      return this.getChildrenBlockByType('totalTurnVpkAmount')
    }
  },
  methods: {
    getRouteSourceByType: function (type) {
      return this.sourceClaim && this.sourceClaim.routeSource && this.sourceClaim.routeSource.find(routeSource => routeSource.type && routeSource.type === type) || null
    },
    getChildrenBlockByType: function (type) {
      const routeSourceChildrens = this.turnHLRouteSource && this.turnHLRouteSource.compound && this.turnHLRouteSource.compound.flatMap(compound => compound.children)
      return routeSourceChildrens && routeSourceChildrens.find(children => children.type === type)
    }
  }
}
